import * as React from "react";
const IconSeoAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M15.7 23.7h3.1c.6 0 1-.4 1-1s-.4-1-1-1h-3.1c-2.3 0-4.1 1.8-4.1 4.1v3.1c0 2.3 1.8 4.1 4.1 4.1 1.2 0 2.1.9 2.1 2.1v3.1c0 1.2-.9 2.1-2.1 2.1h-3.1c-.6 0-1 .4-1 1s.4 1 1 1h3.1c2.3 0 4.1-1.8 4.1-4.1v-3.1c0-2.3-1.8-4.1-4.1-4.1-1.2 0-2.1-.9-2.1-2.1v-3.1c0-1.2.9-2.1 2.1-2.1M30.8 23.7h4.4c.6 0 1-.4 1-1s-.4-1-1-1h-4.4c-2.3 0-4.1 1.8-4.1 4.1v12.4c0 2.3 1.8 4.1 4.1 4.1h4.4c.6 0 1-.4 1-1s-.4-1-1-1h-4.4c-1.2 0-2.1-.9-2.1-2.1V33h3.9000000000000004c.6 0 1-.4 1-1s-.4-1-1-1h-3.9000000000000004v-5.3c-.1-1.1.9-2 2.1-2M48.3 21.7h-2.4c-2.3 0-4.2 1.9-4.2 4.1v12.3c0 2.3 1.9 4.1 4.2 4.1h2.4c2.3 0 4.2-1.9 4.2-4.1V25.8c-.1-2.3-2-4.1-4.2-4.1m2.1 16.5c0 1.2-1 2.1-2.2 2.1h-2.4c-1.2 0-2.2-1-2.2-2.1V25.8c0-1.2 1-2.1 2.2-2.1h2.4c1.2 0 2.2 1 2.2 2.1z" />
    <path d="M58 13H6c-2.2 0-4 1.8-4 4v30c0 2.2 1.8 4 4 4h52c2.2 0 4-1.8 4-4V17c0-2.2-1.8-4-4-4m2 34c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h52c1.1 0 2 .9 2 2z" />
  </svg>
);
export default IconSeoAlt;
